import React, { ReactNode } from "react";
import styled from "styled-components";

interface MilestonesCardProps {
  children: ReactNode;
  margin?: string; // New prop for margin
}

export const MilestonesCard: React.FC<MilestonesCardProps> = ({
  children,
  margin,
}) => {
  // @ts-ignore
  const isNative = window?.ReactNativeWebView;
  return (
    <Container style={{ paddingTop: isNative && "30px" }}>
      <MainWrapper margin={margin}>{children}</MainWrapper>
    </Container>
  );
};

const Container = styled.div`
  /* display: flex; */
  height: 100vh;
  min-height: 100vh;
  max-height: 100%;
  overflow-y: auto;
`;

const MainWrapper = styled.div<MilestonesCardProps>`
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: 24px;
  /* max-height: 100%; */
`;
